import { MantineJasperThemeProvider } from "@jasper/forms";
import { SimpleGrid } from "@mantine/core";
import type { FC } from "react";
import { LoginAside } from "./LoginAside";
import { LoginContent, type LoginPageProps } from "./LoginContent";

export const LoginPage: FC<LoginPageProps> = props => (
  <MantineJasperThemeProvider version="v2">
    <SimpleGrid cols={{ base: 1, md: 2 }} spacing={0} mih="100vh">
      <LoginContent {...props} />
      <LoginAside />
    </SimpleGrid>
  </MantineJasperThemeProvider>
);
